export enum EImageTypes {
  Thumbnail = 1,
  ExtendedFocus = 2,
  BestFocus = 3,
  FocusLevel = 4,
  DropLocation = 5,
  SecondaryExtendedFocus = 6,
  BestSlice = 7,
}

export default EImageTypes;
